import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import Flatpickr from "react-flatpickr";
import Icon from "Components/Icons/Icon";

interface Props {
  onDateSelect?: (range: { start: Date; end: Date }) => void;
}

const DateRangeSelector: React.FC<Props> = ({ onDateSelect }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isCustom, setIsCustom] = useState(false);
  const [selectedLabel, setSelectedLabel] =
    useState<string>("Select Date Range");

  const toggle = () => {
    setDropdownOpen((prev) => !prev);
  };

  const formatDate = (date: Date) =>
    date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });

  const ranges = [
    { label: "Past 7 Days", days: 7 },
    { label: "Past 14 Days", days: 14 },
    { label: "Past 1 Month", days: 30 },
    { label: "Past 3 Months", days: 90 },
    { label: "Past 6 Months", days: 180 },
    { label: "Past 12 Months", days: 365 },
  ];

  const applyRange = (label: string, days: number) => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);

    setSelectedLabel(`${formatDate(start)} – ${formatDate(end)}`);
    onDateSelect?.({ start, end });
  };

  const handleCustomRange = (selectedDates: any) => {
    if (selectedDates.length === 2) {
      const [start, end] = selectedDates;
      setSelectedLabel(`${formatDate(start)} – ${formatDate(end)}`);
      onDateSelect?.({ start, end });
      setIsCustom(false);
    }
  };

  return (
    <div className="date-range-selector">
      {!isCustom ? (
        <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle className="date-range-toggle" caret={false}>
            <div className="d-flex align-items-center pe-2 me-2 border-end border-greyE4 my-n3">
              <Icon name="Calendar" />
            </div>

            <span>{selectedLabel}</span>
          </DropdownToggle>
          <DropdownMenu>
            {ranges.map((r) => (
              <DropdownItem
                key={r.label}
                onClick={() => applyRange(r.label, r.days)}
              >
                {r.label}
              </DropdownItem>
            ))}
            <DropdownItem divider />
            <DropdownItem onClick={() => setIsCustom(true)}>
              Custom Date Range
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      ) : (
        <div className="date-range-toggle">
          <div className="d-flex align-items-center pe-2 me-2 border-end border-greyE4 my-n3">
            <Icon name="Calendar" />
          </div>
          <Flatpickr
            options={{
              maxDate: new Date(),
              mode: "range",
              dateFormat: "Y-m-d",
            }}
            onChange={handleCustomRange}
            placeholder="Select date range"
            className="border-0 text-grey89 "
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;
